import { render, staticRenderFns } from "./guided-tour-host.vue?vue&type=template&id=5dd79bd0&scoped=true&"
import script from "./guided-tour-host.vue?vue&type=script&lang=js&"
export * from "./guided-tour-host.vue?vue&type=script&lang=js&"
import style0 from "./guided-tour-host.vue?vue&type=style&index=0&id=5dd79bd0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd79bd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dd79bd0')) {
      api.createRecord('5dd79bd0', component.options)
    } else {
      api.reload('5dd79bd0', component.options)
    }
    module.hot.accept("./guided-tour-host.vue?vue&type=template&id=5dd79bd0&scoped=true&", function () {
      api.rerender('5dd79bd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/global/components/guided-tour/guided-tour-host.vue"
export default component.exports